/**
 * Plain, non-interactive stat tile: eyebrow label + big number.
 *
 * Moved verbatim out of pages/admin/AdminStats.tsx so client-facing pages can
 * use it too. docs/design-guidelines.md resolves this as THE shape for a plain
 * count/metric display and rules MetricCard out for it (MetricCard is a
 * clickable nav card built around a completion percentage). Don't add a click
 * affordance or a progress bar here — that would recreate MetricCard.
 *
 * `value` accepts a string so callers can render fractions like "3 of 5".
 */
export function StatCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
      <p className="text-xs font-bold uppercase tracking-[0.08em] text-slate-400">{label}</p>
      <p className="mt-2 text-3xl font-bold">{value}</p>
    </div>
  );
}
